import { useEffect, useRef, useState } from 'react';
import { register, call, remove } from '../funcStore';
import FilterSelect from './FilterSelect';

const styles = {
  filterGroup: {
    border: '1px solid #e5e5e5',
    borderRadius: '6px',
    overflow: 'hidden',
  },
  filterGroupHeader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 10px',
    border: 'none',
    background: '#f3f2f9',
    color: '#333',
    fontSize: '0.85rem',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  filterGroupBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '10px',
  },
};

const STATE_BEFORE_INIT = 'beforeInit';
const STATE_EXPANDED = 'expanded';
const STATE_COLLAPSED = 'collapsed';

function FilterGroup({ groupKey }) {
  const [state, setState] = useState(STATE_BEFORE_INIT);

  const stateRef = useRef(state);
  stateRef.current = state;

  const funcKeyRef = useRef(`filterGroup.${groupKey}`);
  const funcKey = funcKeyRef.current;

  const dataRef = useRef({
    title: '',
    filters: [],
  });

  const init = () => {
    const group = call('searchPage.getFilterGroup', groupKey);

    dataRef.current.title = group ? group.title : '';
    dataRef.current.filters = group ? group.filters : [];

    register(`${funcKey}.getState`, () => stateRef.current);

    register(`${funcKey}.toggle`, () => {
      setState(
        stateRef.current === STATE_EXPANDED ? STATE_COLLAPSED : STATE_EXPANDED
      );
    });

    register(`${funcKey}.open`, () => {
      setState(STATE_EXPANDED);
    });

    register(`${funcKey}.update`, () => {
      dataRef.current.filters.forEach(({ key }) => {
        call(`filterSelect.${groupKey}.${key}.refresh`);
      });
    });

    setState(STATE_COLLAPSED);
  };

  useEffect(() => {
    if (state === STATE_BEFORE_INIT) {
      init();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  useEffect(() => {
    return () => {
      remove(`${funcKey}.getState`);
      remove(`${funcKey}.toggle`);
      remove(`${funcKey}.open`);
      remove(`${funcKey}.update`);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (state === STATE_BEFORE_INIT) {
    return null;
  }

  const handleToggle = () => {
    call(`${funcKey}.toggle`);
  };

  return (
    <div style={styles.filterGroup}>
      <button
        type="button"
        style={styles.filterGroupHeader}
        onClick={handleToggle}
        aria-expanded={state === STATE_EXPANDED}
      >
        <span>{dataRef.current.title}</span>
        <span>{state === STATE_EXPANDED ? '▲' : '▼'}</span>
      </button>

      {state === STATE_EXPANDED && (
        <div style={styles.filterGroupBody}>
          {dataRef.current.filters.map(({ key, label, options }) => (
            <FilterSelect
              key={key}
              groupKey={groupKey}
              filterKey={key}
              label={label}
              options={options}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default FilterGroup;
